// TODO: Replace with actual DealerRater logo
// Using BBB icon as placeholder for now

export function DealerRaterIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg"
	 width={562} viewBox="0 0 960 720" style={{ stroke: 'none' }}>
<path fill="#FFF" opacity="0.000000" stroke="none" 
	d="
M441.000000,721.000000 
	C294.431610,721.000000 147.863235,721.000000 1.000000,721.000000 
	C1.000000,651.978271 1.000000,582.956116 1.291690,513.163574 
	C4.722362,517.714233 10.282993,518.895996 15.454911,518.833557 
	C31.479614,518.640198 47.563526,518.391602 63.497925,516.853577 
	C86.689308,514.615051 100.676048,500.409149 107.977974,479.108490 
	C112.350967,466.351898 113.027603,453.215485 111.088768,439.809448 
	C109.117439,426.178711 104.000839,414.094757 94.546097,404.147339 
	C82.798180,391.787140 67.183289,388.882324 51.141544,388.109924 
	C39.336014,387.541504 27.473999,387.769684 15.652507,388.136993 
	C12.066916,388.248413 8.473341,389.842682 5.002377,391.089020 
	C3.511998,391.624176 2.324903,393.003967 1.000006,394.000000 
	C1.000000,263.068298 1.000000,132.136612 1.000000,1.000000 
	C147.355286,1.000000 293.710663,1.000000 440.852844,1.356053 
	C440.965240,2.133410 440.329102,2.832907 439.610352,2.931773 
	C434.128265,3.685852 428.538940,3.903359 423.153717,5.073451 
	C405.879608,8.826724 388.506531,12.297326 371.489746,17.022573 
	C344.435425,24.535070 319.425903,36.892914 295.142548,50.904865 
	C269.080750,65.943024 245.774261,84.560760 224.389603,105.461411 
	C212.740555,116.846809 202.028137,129.418152 192.344788,142.526840 
	C181.384155,157.364655 171.248169,172.952576 162.200790,189.028778 
	C149.514648,211.570648 139.345276,235.359451 132.850189,260.525024 
	C129.999527,271.570038 127.283951,282.669769 125.095520,293.859772 
	C123.259010,303.250305 121.956345,312.775604 120.996918,322.299652 
	C119.782410,334.355743 119.154778,346.471008 118.256645,358.799438 
	C135.528824,358.799438 151.601669,358.799438 168.037888,358.799438 
	C167.361282,338.236298 169.954941,318.176758 174.000809,298.272552 
	C178.684708,275.229523 185.887909,252.992218 195.791763,231.670853 
	C206.063309,209.557877 218.350723,188.675415 233.751724,169.656250 
	C244.262848,156.675720 255.026642,144.077576 267.472931,132.777695 
	C281.610657,119.942154 296.149902,107.707298 312.603424,98.118103 
	C327.988800,89.151443 343.651611,80.435135 359.929596,73.287750 
	C377.072174,65.760727 395.001099,59.882702 413.626953,56.827202 
	C428.505829,54.386379 443.380066,50.962830 458.358307,50.308510 
	C480.257385,49.351860 502.353699,48.669662 524.084900,53.050316 
	C538.906616,56.038113 553.775208,58.974606 568.363220,62.899128 
	C592.194763,69.310379 614.536255,79.536263 635.739563,92.073837 
	C645.524048,97.859421 654.708862,104.659332 664.011230,111.317078 
	C656.026245,117.795692 647.908997,123.629280 640.423462,130.184250 
	C623.815308,144.727707 607.098572,159.191879 591.215515,174.507019 
	C573.027893,192.044373 555.614014,210.389755 538.023010,228.538147 
	C528.237976,238.633194 518.759399,249.025970 509.178741,259.318085 
	C505.811615,262.935211 502.559113,266.658875 499.241638,270.322449 
	C490.727783,279.724518 482.206818,289.120087 473.274353,298.975372 
	C464.900543,290.530548 457.385254,282.538940 449.423737,275.019806 
	C437.663483,263.913055 426.229523,252.312073 413.485443,242.432266 
	C396.384369,229.174728 377.550842,218.476547 357.231995,210.625565 
	C330.275757,200.209961 302.661102,194.899643 273.796143,200.100555 
	C267.719238,201.195480 260.870728,203.096756 259.314148,210.001709 
	C257.731964,217.020294 258.259918,225.935516 267.138245,230.495804 
	C276.762909,235.439407 286.664520,239.932388 296.724304,243.917694 
	C308.766846,248.688492 321.423218,251.992508 333.247528,257.213989 
	C356.963776,267.686798 378.344482,282.162567 397.623322,299.378540 
	C412.866608,312.990784 426.658081,328.101227 438.096252,345.234039 
	C445.326447,356.063904 452.733582,366.820190 460.769073,377.053802 
	C467.267975,385.330505 476.836945,385.214935 486.106140,383.292389 
	C495.416870,381.361237 501.482025,374.212006 506.799164,367.256592 
	C521.420776,348.129730 534.653442,327.915527 549.707275,309.151703 
	C565.331421,289.676941 582.037048,271.017975 599.041626,252.719589 
	C611.808716,238.981247 625.768005,226.347839 639.254700,213.282501 
	C645.800842,206.940887 652.314209,200.549438 659.132263,194.507660 
	C675.607117,179.908569 692.252380,165.501785 708.962646,151.334045 
	C719.517456,165.055557 730.988342,177.790970 740.078430,192.044693 
	C750.135742,207.815140 759.106079,224.500748 766.558044,241.653107 
	C775.369995,261.935638 782.227539,283.106110 785.009277,305.272736 
	C786.813354,319.648560 788.418030,334.050781 789.945984,348.458801 
	C790.306824,351.861328 789.999451,355.334747 789.999451,358.753662 
	C806.546509,358.753662 822.610840,358.753662 838.889343,358.753662 
	C839.498108,340.925873 838.496216,323.432343 834.972229,306.200775 
	C831.365967,288.567352 827.809387,270.874298 823.008850,253.545898 
	C815.300659,225.721771 802.969788,199.741074 787.882812,175.205688 
	C779.721436,161.933044 770.272583,149.440460 761.177185,136.758957 
	C757.021729,130.965149 752.317078,125.565285 748.009277,119.668884 
	C768.015869,105.492737 787.440918,90.952377 807.854980,77.966812 
	C828.520203,64.821510 850.133911,53.162239 871.390076,40.952999 
	C884.358459,33.504128 897.565063,26.458794 910.356140,18.721903 
	C912.906555,17.179222 915.563965,13.274060 915.479370,10.541607 
	C915.367554,6.930059 912.920593,3.108761 907.992676,2.845575 
	C907.629944,2.826207 907.329468,1.642422 907.000000,0.999990 
	C924.983765,1.000000 942.967468,1.000000 961.000000,1.000000 
	C961.000000,143.022003 961.000000,285.044037 960.688049,427.783264 
	C954.888367,421.710632 948.250244,419.330383 941.014832,421.438416 
	C933.382385,423.662140 927.739990,428.213898 924.252441,436.407623 
	C924.085815,434.607849 924.129883,433.766510 923.917969,432.995544 
	C921.531799,424.317139 916.727051,421.021667 907.976013,422.009888 
	C901.850769,422.701599 897.068970,428.102386 897.039185,434.996124 
	C896.937073,458.625916 896.922791,482.256805 897.044189,505.886444 
	C897.084595,513.755615 900.567444,518.058533 907.496948,519.787659 
	C914.460693,521.525452 923.691406,517.576843 924.843384,512.119995 
	C925.547363,508.785156 925.910889,505.323486 925.950073,501.913269 
	C926.081970,490.432495 925.785400,478.944122 926.059998,467.468384 
	C926.339355,455.791626 931.971497,446.636169 944.660706,446.884216 
	C947.996033,446.949402 951.532288,446.099915 954.650635,444.854828 
	C957.033447,443.903473 958.902466,441.665619 961.000000,440.000000 
	C961.000000,533.610535 961.000000,627.221130 961.000000,721.000000 
	C813.311340,721.000000 665.622681,721.000000 517.146729,720.640259 
	C517.201904,719.855042 518.004150,719.187744 518.892700,719.040222 
	C533.256470,716.655151 547.765320,714.952820 561.973450,711.864075 
	C586.012756,706.638184 609.197632,698.519775 631.355591,687.827759 
	C643.953430,681.748840 656.298035,675.043945 668.305725,667.866455 
	C687.535400,656.371826 705.460632,642.964355 721.788391,627.609924 
	C740.135071,610.356995 757.387024,592.047729 772.001953,571.438721 
	C776.594360,564.962769 780.820129,558.226990 785.618469,551.000610 
	C765.547241,551.000610 746.410278,550.973633 727.273926,551.071655 
	C726.198242,551.077148 724.837952,551.859009 724.099670,552.706177 
	C716.477905,561.451355 709.409851,570.731323 701.282410,578.969299 
	C692.897400,587.468384 683.599792,595.082947 674.538269,602.895264 
	C660.320679,615.152710 644.620117,625.304382 628.191833,634.276306 
	C610.703186,643.827454 592.521667,651.911133 573.459229,657.828552 
	C543.934021,666.993774 513.840271,672.288391 482.765442,672.123901 
	C465.263092,672.031189 447.799622,671.703491 430.558960,668.864624 
	C411.521851,665.729919 392.894623,660.832642 374.630280,654.370300 
	C356.067627,647.802551 338.359772,639.467834 321.450134,629.608765 
	C305.687164,620.418152 291.016296,609.560303 277.016846,597.705078 
	C262.545532,585.450256 249.388916,572.104797 237.687866,557.238892 
	C234.568924,553.276306 231.429764,550.457764 225.255524,550.748413 
	C209.294556,551.499695 193.274719,550.994019 177.278397,551.010803 
	C175.887543,551.012268 174.496841,551.164978 172.500458,551.283264 
	C173.590210,552.889832 174.308289,553.900391 174.977722,554.942322 
	C188.492828,575.977966 203.661285,595.691650 221.651550,613.132263 
	C228.659027,619.925598 235.506012,626.921265 242.910294,633.259094 
	C251.764633,640.838135 260.913513,648.118591 270.331940,654.983643 
	C290.836823,669.929443 312.781982,682.524536 336.354828,691.901733 
	C353.151031,698.583313 370.161346,705.090759 387.600067,709.688782 
	C404.408142,714.120483 421.892212,715.982117 439.061401,719.072083 
	C439.799347,719.204895 440.357880,720.334656 441.000000,721.000000 
M531.999817,401.883362 
	C531.999817,436.527344 531.998718,471.171295 532.000916,505.815277 
	C532.001404,512.855408 534.458191,516.644226 540.674011,519.223755 
	C546.151184,521.496643 553.652893,520.218201 557.474182,515.880249 
	C559.093140,514.042358 560.721313,511.503387 560.861389,509.193054 
	C561.522644,498.290100 561.677124,487.356232 561.993713,476.432800 
	C562.044250,474.689056 562.000793,472.942596 562.000793,471.003143 
	C570.619385,471.003143 578.446777,470.798645 586.257690,471.070007 
	C592.151733,471.274750 597.282837,473.544495 599.630859,479.404053 
	C600.886719,482.538116 601.210815,486.040649 602.008118,489.364227 
	C603.819702,496.915680 604.716858,504.865204 607.733521,511.903839 
	C611.539856,520.785034 619.430908,521.781067 628.295654,519.057617 
	C636.221313,516.622681 637.691223,510.794464 635.070312,501.235962 
	C633.222534,494.497070 632.665344,487.408722 630.897278,480.642273 
	C629.271667,474.421021 627.382263,468.119751 624.455078,462.449432 
	C622.956543,459.546814 618.932312,457.948090 617.182068,456.619598 
	C621.502014,452.915039 626.446106,449.683929 630.064636,445.346802 
	C636.221191,437.967499 636.665955,428.951813 636.148743,419.584991 
	C635.581787,409.318939 630.699097,402.062317 623.014832,395.967255 
	C614.492188,389.207123 604.166199,388.655396 594.193237,388.188965 
	C578.737183,387.466095 563.219971,387.832703 547.733521,388.063232 
	C538.521790,388.200348 533.309021,392.785797 531.999817,401.883362 
M252.248001,443.289124 
	C257.569702,443.195770 263.050232,442.303925 268.151611,443.318481 
	C271.057587,443.896423 273.344482,447.587219 275.910217,449.876282 
	C273.583160,451.903229 271.482819,454.330139 268.852020,455.821167 
	C266.996246,456.872925 264.382446,456.496399 262.173126,457.030701 
	C251.481384,459.616394 240.688492,461.888763 230.179642,465.087616 
	C223.573578,467.098450 218.850327,471.906372 216.611023,478.792603 
	C214.894547,484.071106 214.103210,489.251678 214.863068,494.929047 
	C216.142593,504.489044 220.325516,512.003296 228.880035,516.304016 
	C246.334122,525.079041 262.563843,521.622192 277.948730,510.428101 
	C278.430756,511.216370 279.104828,512.135559 279.592102,513.144958 
	C283.006836,520.218079 290.349274,521.916443 297.183289,518.744690 
	C303.299957,515.905823 304.859802,509.344910 304.869263,503.270813 
	C304.898132,484.694031 304.880493,466.084564 303.801636,447.550629 
	C303.136200,436.119263 296.267090,428.184174 285.398376,423.977264 
	C273.743805,419.466156 261.555634,420.101074 249.631027,421.262207 
	C240.414078,422.159698 231.311539,425.157837 225.258636,433.261017 
	C220.399216,439.766418 220.933899,446.418823 226.235168,450.999084 
	C232.227356,456.176300 240.600540,454.825500 245.156479,448.820618 
	C246.747055,446.724152 249.453125,445.474030 252.248001,443.289124 
M687.552917,442.026642 
	C689.980225,442.369141 692.441833,442.557648 694.827026,443.089111 
	C698.717407,443.955902 702.565674,445.953827 702.640320,450.095551 
	C702.710876,454.006836 698.802979,455.298615 695.241333,456.003693 
	C685.336792,457.964417 675.369019,459.672546 665.561096,462.039459 
	C647.455811,466.408813 639.982849,477.304901 641.977661,495.365051 
	C643.737854,511.301575 655.820190,519.684570 670.666992,520.937683 
	C683.283508,522.002563 695.010559,519.480469 704.550964,510.255890 
	C709.557922,521.986084 722.669739,523.402344 728.313538,514.950439 
	C730.432434,511.777161 731.822693,507.451996 731.831726,503.647949 
	C731.875916,485.056030 731.770386,466.441864 730.867798,447.876892 
	C730.217651,434.503693 720.422668,425.718506 709.208984,423.302368 
	C699.501160,421.210663 689.192383,420.741547 679.241882,421.276855 
	C669.676758,421.791443 660.339417,424.542114 653.236633,432.149261 
	C648.304688,437.431458 647.978760,445.596161 651.985779,450.473755 
	C655.774231,455.085236 665.657043,455.716888 670.366943,450.885590 
	C675.038025,446.093994 679.827820,442.408936 687.552917,442.026642 
M209.997726,452.779144 
	C209.667633,451.705017 209.379303,450.615967 209.001083,449.559082 
	C204.568954,437.173889 197.136993,427.345306 184.221558,423.214630 
	C176.526199,420.753479 168.604874,419.651794 160.200668,420.820435 
	C143.640106,423.123322 130.983063,430.593262 123.185326,445.547516 
	C117.919945,455.645325 116.987679,466.467346 117.932365,477.702728 
	C119.341751,494.464844 126.555923,507.422272 141.413727,515.769836 
	C152.122696,521.786377 163.972229,522.076599 175.477921,520.657715 
	C182.914734,519.740662 190.278549,516.266052 197.088181,512.788391 
	C203.736069,509.393250 205.950653,501.329224 203.160477,495.499298 
	C199.072586,486.957855 189.505463,485.273254 182.562759,491.983337 
	C177.355881,497.015717 171.568634,500.172729 164.058441,498.536469 
	C153.702866,496.280243 148.412918,489.653351 147.300934,479.000244 
	C149.175964,479.000244 150.831284,479.000183 152.486603,479.000183 
	C168.978058,479.000092 185.469543,479.010620 201.960983,478.993134 
	C206.570679,478.988251 210.903336,475.851471 210.907211,471.909424 
	C210.913193,465.822845 210.333771,459.735718 209.997726,452.779144 
M430.531708,487.999725 
	C427.250275,489.602142 423.585785,490.713837 420.769562,492.912201 
	C415.401459,497.102661 410.013519,499.919159 402.881989,498.482025 
	C392.270355,496.343567 388.138550,488.909729 386.084564,479.210602 
	C387.155884,479.128235 387.976898,479.010529 388.798004,479.010010 
	C406.291840,478.998810 423.785706,479.018768 441.279480,478.989563 
	C446.765717,478.980408 449.687531,476.445740 449.953339,471.169373 
	C450.180023,466.669373 450.546112,462.068176 449.894470,457.652893 
	C448.090515,445.430115 442.925903,434.875244 432.354889,427.807129 
	C419.574860,419.261963 405.430206,418.850433 391.161926,422.508850 
	C376.585846,426.246155 366.471741,435.250671 360.602936,449.508270 
	C356.800629,458.745667 356.683289,468.099060 357.085052,477.576172 
	C357.710510,492.329468 364.256775,504.234100 376.132080,512.999695 
	C387.748657,521.574402 401.406372,522.155945 414.791901,520.629883 
	C422.226532,519.782166 429.601440,516.186035 436.398834,512.662598 
	C442.065521,509.725311 444.385284,503.820404 442.869781,497.434937 
	C441.509491,491.703674 437.315552,488.570526 430.531708,487.999725 
M852.784424,497.669952 
	C838.071838,503.057190 824.466675,491.309845 825.611206,479.000000 
	C843.386902,479.000000 861.194763,479.002380 879.002563,478.998688 
	C885.367126,478.997375 889.072021,475.415161 888.952209,468.959717 
	C888.860657,464.025391 888.876770,458.988373 887.896423,454.190887 
	C885.378662,441.869812 878.718445,432.336151 867.688049,425.879730 
	C858.656433,420.593323 848.798889,420.470306 838.953674,421.089752 
	C822.831604,422.104095 810.074280,429.540894 802.205078,443.721252 
	C794.783325,457.095367 792.913025,471.576538 797.045898,486.519440 
	C801.037903,500.952972 808.725281,512.475769 823.458923,517.717773 
	C836.847595,522.481323 850.584961,522.701477 864.035217,518.296326 
	C869.141418,516.623962 874.140015,513.572510 878.203003,510.022522 
	C883.681946,505.235382 883.310364,497.022522 878.424011,491.918976 
	C873.369507,486.639862 866.516418,486.736572 860.459534,491.988770 
	C858.261658,493.894745 855.759766,495.450104 852.784424,497.669952 
M786.425720,497.976562 
	C785.166504,497.652466 783.923584,497.151581 782.645386,497.034088 
	C776.196289,496.441101 775.004944,495.223328 775.002502,488.889648 
	C774.997437,475.904785 775.001282,462.919952 775.001404,449.935089 
	C775.001404,448.017334 775.001343,446.099579 775.001343,444.238129 
	C787.330994,443.493164 791.531555,440.963623 791.887207,433.930145 
	C792.004517,431.609009 791.656433,428.007324 790.202942,427.097717 
	C785.709839,424.285980 780.581482,422.489349 775.720398,420.307800 
	C774.921509,414.182648 774.400513,407.132904 772.976501,400.270508 
	C771.906250,395.112701 766.337891,391.936584 760.452698,392.022766 
	C755.194336,392.099762 748.726196,396.613892 748.078491,401.446503 
	C747.184570,408.115814 746.986572,414.878418 746.487427,421.642212 
	C734.629028,425.495636 732.446228,427.615326 732.998352,434.807831 
	C733.399292,440.029602 738.185669,443.424469 747.000000,444.419037 
	C747.000000,446.133728 747.000000,447.926605 747.000000,449.719482 
	C746.999939,466.366730 746.800598,483.017242 747.071716,499.660095 
	C747.245117,510.304657 751.568848,516.675354 760.967224,518.228088 
	C768.585022,519.486755 776.580811,519.292542 784.322815,518.670471 
	C789.455566,518.257996 792.838867,513.364990 793.001953,508.740234 
	C793.167480,504.045715 793.342773,499.356445 786.425720,497.976562 
M316.000000,405.544037 
	C315.999878,439.352448 315.987762,473.160828 316.009644,506.969238 
	C316.014038,513.790771 319.884613,518.734497 326.019104,519.966064 
	C333.331390,521.434082 340.403931,518.128357 342.504913,511.886932 
	C343.424896,509.153992 343.918884,506.148285 343.937317,503.262146 
	C344.059570,484.110382 344.000214,464.957458 344.000153,445.804932 
	C344.000122,430.982544 344.296112,416.151917 343.885162,401.340942 
	C343.653809,393.001373 340.984222,388.336426 333.839935,387.213806 
	C326.459808,386.054138 319.306396,386.487213 316.789825,394.823456 
	C315.869568,397.871826 316.226013,401.305573 316.000000,405.544037 
M459.209106,511.703766 
	C459.460175,512.119995 459.698029,512.544922 459.964264,512.951233 
	C463.854462,518.887085 470.552612,521.444885 477.037231,519.475281 
	C484.272217,517.277832 486.998901,513.382263 486.999908,505.239868 
	C487.000488,500.575073 486.894928,495.907379 487.021912,491.246063 
	C487.283203,481.655212 487.314026,472.037811 488.121948,462.489044 
	C488.703735,455.613098 492.107483,449.843475 499.072083,447.613434 
	C502.889954,446.390961 507.120911,446.345245 511.185913,446.034760 
	C517.075745,445.584869 521.339294,441.777313 521.994446,436.066010 
	C522.847168,428.632477 520.235291,424.112915 514.312073,421.949677 
	C505.844940,418.857391 492.258392,422.646667 487.916962,432.302399 
	C487.455658,433.328430 486.619812,434.186066 485.443451,435.848724 
	C485.192200,434.147461 485.077911,433.517303 485.008636,432.882233 
	C484.294281,426.335785 480.510712,422.509186 473.310730,421.061890 
	C469.355927,420.266876 461.545502,424.260834 460.273224,428.731628 
	C458.862183,433.690002 458.072174,439.004852 458.093689,444.159973 
	C458.186493,466.405609 458.675751,488.649597 459.209106,511.703766 
M833.521667,542.025818 
	C828.966797,538.538391 824.331970,535.683350 818.117615,535.912231 
	C808.388062,536.270630 800.767334,541.655273 798.400940,551.248962 
	C796.741150,557.977661 798.225220,567.629333 807.407654,572.700012 
	C815.574829,577.210083 825.700989,576.094971 832.356384,570.123169 
	C838.907166,564.245117 840.683533,552.055115 833.521667,542.025818 
z"/>
<path fill="#FA7412" opacity="1.000000" stroke="none" 
	d="
M708.828979,151.017502 
	C692.252380,165.501785 675.607117,179.908569 659.132263,194.507660 
	C652.314209,200.549438 645.800842,206.940887 639.254700,213.282501 
	C625.768005,226.347839 611.808716,238.981247 599.041626,252.719589 
	C582.037048,271.017975 565.331421,289.676941 549.707275,309.151703 
	C534.653442,327.915527 521.420776,348.129730 506.799164,367.256592 
	C501.482025,374.212006 495.416870,381.361237 486.106140,383.292389 
	C476.836945,385.214935 467.267975,385.330505 460.769073,377.053802 
	C452.733582,366.820190 445.326447,356.063904 438.096252,345.234039 
	C426.658081,328.101227 412.866608,312.990784 397.623322,299.378540 
	C378.344482,282.162567 356.963776,267.686798 333.247528,257.213989 
	C321.423218,251.992508 308.766846,248.688492 296.724304,243.917694 
	C286.664520,239.932388 276.762909,235.439407 267.138245,230.495804 
	C258.259918,225.935516 257.731964,217.020294 259.314148,210.001709 
	C260.870728,203.096756 267.719238,201.195480 273.796143,200.100555 
	C302.661102,194.899643 330.275757,200.209961 357.231995,210.625565 
	C377.550842,218.476547 396.384369,229.174728 413.485443,242.432266 
	C426.229523,252.312073 437.663483,263.913055 449.423737,275.019806 
	C457.385254,282.538940 464.900543,290.530548 473.274353,298.975372 
	C482.206818,289.120087 490.727783,279.724518 499.241638,270.322449 
	C502.559113,266.658875 505.811615,262.935211 509.178741,259.318085 
	C518.759399,249.025970 528.237976,238.633194 538.023010,228.538147 
	C555.614014,210.389755 573.027893,192.044373 591.215515,174.507019 
	C607.098572,159.191879 623.815308,144.727707 640.423462,130.184250 
	C647.908997,123.629280 656.026245,117.795692 664.360168,111.304863 
	C665.600952,110.635376 666.397339,110.385010 667.067383,109.943115 
	C679.770752,101.565430 692.467163,93.176941 705.136475,84.747841 
	C706.195312,84.043388 707.050659,83.033066 708.321533,82.008591 
	C728.458740,70.374603 748.023376,58.430233 768.172852,47.571041 
	C783.495789,39.313038 799.304688,31.819464 815.363892,25.100756 
	C834.473999,17.105639 854.087524,10.315043 873.455933,2.931562 
	C874.119629,2.678549 874.491882,1.661102 875.000000,0.999990 
	C885.354248,1.000000 895.708435,1.000000 906.531372,0.999990 
	C907.329468,1.642422 907.629944,2.826207 907.992676,2.845575 
	C912.920593,3.108761 915.367554,6.930059 915.479370,10.541607 
	C915.563965,13.274060 912.906555,17.179222 910.356140,18.721903 
	C897.565063,26.458794 884.358459,33.504128 871.390076,40.952999 
	C850.133911,53.162239 828.520203,64.821510 807.854980,77.966812 
	C787.440918,90.952377 768.015869,105.492737 747.658936,119.677444 
	C737.381348,127.558449 727.545959,135.042465 717.853760,142.707581 
	C714.655334,145.237091 711.826721,148.234222 708.828979,151.017502 
z"/>
<path fill="#CFE5F2" opacity="1.000000" stroke="none" 
	d="
M708.000488,82.164825 
	C707.050659,83.033066 706.195312,84.043388 705.136475,84.747841 
	C692.467163,93.176941 679.770752,101.565430 667.067383,109.943115 
	C666.397339,110.385010 665.600952,110.635376 664.514526,110.987137 
	C654.708862,104.659332 645.524048,97.859421 635.739563,92.073837 
	C614.536255,79.536263 592.194763,69.310379 568.363220,62.899128 
	C553.775208,58.974606 538.906616,56.038113 524.084900,53.050316 
	C502.353699,48.669662 480.257385,49.351860 458.358307,50.308510 
	C443.380066,50.962830 428.505829,54.386379 413.626953,56.827202 
	C395.001099,59.882702 377.072174,65.760727 359.929596,73.287750 
	C343.651611,80.435135 327.988800,89.151443 312.603424,98.118103 
	C296.149902,107.707298 281.610657,119.942154 267.472931,132.777695 
	C255.026642,144.077576 244.262848,156.675720 233.751724,169.656250 
	C218.350723,188.675415 206.063309,209.557877 195.791763,231.670853 
	C185.887909,252.992218 178.684708,275.229523 174.000809,298.272552 
	C169.954941,318.176758 167.361282,338.236298 168.037888,358.799438 
	C151.601669,358.799438 135.528824,358.799438 118.256645,358.799438 
	C119.154778,346.471008 119.782410,334.355743 120.996918,322.299652 
	C121.956345,312.775604 123.259010,303.250305 125.095520,293.859772 
	C127.283951,282.669769 129.999527,271.570038 132.850189,260.525024 
	C139.345276,235.359451 149.514648,211.570648 162.200790,189.028778 
	C171.248169,172.952576 181.384155,157.364655 192.344788,142.526840 
	C202.028137,129.418152 212.740555,116.846809 224.389603,105.461411 
	C245.774261,84.560760 269.080750,65.943024 295.142548,50.904865 
	C319.425903,36.892914 344.435425,24.535070 371.489746,17.022573 
	C388.506531,12.297326 405.879608,8.826724 423.153717,5.073451 
	C428.538940,3.903359 434.128265,3.685852 439.610352,2.931773 
	C440.329102,2.832907 440.965240,2.133410 441.319824,1.356053 
	C466.020905,1.000000 491.041779,1.000000 516.211548,1.356097 
	C517.034546,2.133451 517.666626,2.822662 518.389038,2.935819 
	C529.433167,4.665867 540.532166,6.078779 551.533630,8.040991 
	C578.479431,12.847005 604.183655,21.658230 629.015625,33.022270 
	C657.427917,46.024796 683.603210,62.680149 708.000488,82.164825 
z"/>
<path fill="#CFE5F2" opacity="1.000000" stroke="none" 
	d="
M441.468658,721.000000 
	C440.357880,720.334656 439.799347,719.204895 439.061401,719.072083 
	C421.892212,715.982117 404.408142,714.120483 387.600067,709.688782 
	C370.161346,705.090759 353.151031,698.583313 336.354828,691.901733 
	C312.781982,682.524536 290.836823,669.929443 270.331940,654.983643 
	C260.913513,648.118591 251.764633,640.838135 242.910294,633.259094 
	C235.506012,626.921265 228.659027,619.925598 221.651550,613.132263 
	C203.661285,595.691650 188.492828,575.977966 174.977722,554.942322 
	C174.308289,553.900391 173.590210,552.889832 172.500458,551.283264 
	C174.496841,551.164978 175.887543,551.012268 177.278397,551.010803 
	C193.274719,550.994019 209.294556,551.499695 225.255524,550.748413 
	C231.429764,550.457764 234.568924,553.276306 237.687866,557.238892 
	C249.388916,572.104797 262.545532,585.450256 277.016846,597.705078 
	C291.016296,609.560303 305.687164,620.418152 321.450134,629.608765 
	C338.359772,639.467834 356.067627,647.802551 374.630280,654.370300 
	C392.894623,660.832642 411.521851,665.729919 430.558960,668.864624 
	C447.799622,671.703491 465.263092,672.031189 482.765442,672.123901 
	C513.840271,672.288391 543.934021,666.993774 573.459229,657.828552 
	C592.521667,651.911133 610.703186,643.827454 628.191833,634.276306 
	C644.620117,625.304382 660.320679,615.152710 674.538269,602.895264 
	C683.599792,595.082947 692.897400,587.468384 701.282410,578.969299 
	C709.409851,570.731323 716.477905,561.451355 724.099670,552.706177 
	C724.837952,551.859009 726.198242,551.077148 727.273926,551.071655 
	C746.410278,550.973633 765.547241,551.000610 785.618469,551.000610 
	C780.820129,558.226990 776.594360,564.962769 772.001953,571.438721 
	C757.387024,592.047729 740.135071,610.356995 721.788391,627.609924 
	C705.460632,642.964355 687.535400,656.371826 668.305725,667.866455 
	C656.298035,675.043945 643.953430,681.748840 631.355591,687.827759 
	C609.197632,698.519775 586.012756,706.638184 561.973450,711.864075 
	C547.765320,714.952820 533.256470,716.655151 518.892700,719.040222 
	C518.004150,719.187744 517.201904,719.855042 516.679688,720.640259 
	C491.979095,721.000000 466.958221,721.000000 441.468658,721.000000 
z"/>
<path fill="#FFF" opacity="0.000000" stroke="none" 
	d="
M708.321533,82.008583 
	C683.603210,62.680149 657.427917,46.024796 629.015625,33.022270 
	C604.183655,21.658230 578.479431,12.847005 551.533630,8.040991 
	C540.532166,6.078779 529.433167,4.665867 518.389038,2.935819 
	C517.666626,2.822662 517.034546,2.133451 516.680176,1.356097 
	C636.020874,1.000000 755.041809,1.000000 874.531372,0.999990 
	C874.491882,1.661102 874.119629,2.678549 873.455933,2.931562 
	C854.087524,10.315043 834.473999,17.105639 815.363892,25.100756 
	C799.304688,31.819464 783.495789,39.313038 768.172852,47.571041 
	C748.023376,58.430233 728.458740,70.374603 708.321533,82.008583 
z"/>
<path fill="#FA7412" opacity="1.000000" stroke="none" 
	d="
M1.000006,394.468689 
	C2.324903,393.003967 3.511998,391.624176 5.002377,391.089020 
	C8.473341,389.842682 12.066916,388.248413 15.652507,388.136993 
	C27.473999,387.769684 39.336014,387.541504 51.141544,388.109924 
	C67.183289,388.882324 82.798180,391.787140 94.546097,404.147339 
	C104.000839,414.094757 109.117439,426.178711 111.088768,439.809448 
	C113.027603,453.215485 112.350967,466.351898 107.977974,479.108490 
	C100.676048,500.409149 86.689308,514.615051 63.497925,516.853577 
	C47.563526,518.391602 31.479614,518.640198 15.454911,518.833557 
	C10.282993,518.895996 4.722362,517.714233 1.291690,512.696533 
	C1.000000,473.645782 1.000000,434.291534 1.000006,394.468689 
M69.985901,421.484589 
	C58.503632,410.880157 44.517544,414.695282 31.240356,414.081573 
	C31.240356,441.015808 31.240356,467.283783 31.240356,494.437195 
	C38.552948,493.949982 45.579716,493.345062 52.619480,493.041168 
	C67.327988,492.406219 75.111343,482.552216 78.005272,469.624969 
	C79.992050,460.750061 80.663734,451.902344 79.129730,442.783356 
	C77.833298,435.076630 75.990494,427.854919 69.985901,421.484589 
z"/>
<path fill="#107DBF" opacity="1.000000" stroke="none" 
	d="
M961.000000,439.539368 
	C958.902466,441.665619 957.033447,443.903473 954.650635,444.854828 
	C951.532288,446.099915 947.996033,446.949402 944.660706,446.884216 
	C931.971497,446.636169 926.339355,455.791626 926.059998,467.468384 
	C925.785400,478.944122 926.081970,490.432495 925.950073,501.913269 
	C925.910889,505.323486 925.547363,508.785156 924.843384,512.119995 
	C923.691406,517.576843 914.460693,521.525452 907.496948,519.787659 
	C900.567444,518.058533 897.084595,513.755615 897.044189,505.886444 
	C896.922791,482.256805 896.937073,458.625916 897.039185,434.996124 
	C897.068970,428.102386 901.850769,422.701599 907.976013,422.009888 
	C916.727051,421.021667 921.531799,424.317139 923.917969,432.995544 
	C924.129883,433.766510 924.085815,434.607849 924.252441,436.407623 
	C927.739990,428.213898 933.382385,423.662140 941.014832,421.438416 
	C948.250244,419.330383 954.888367,421.710632 960.688049,428.250244 
	C961.000000,431.692902 961.000000,435.385834 961.000000,439.539368 
z"/>
<path fill="#CFE5F2" opacity="1.000000" stroke="none" 
	d="
M708.962646,151.334076 
	C711.826721,148.234222 714.655334,145.237091 717.853760,142.707581 
	C727.545959,135.042465 737.381348,127.558449 747.511230,119.995316 
	C752.317078,125.565285 757.021729,130.965149 761.177185,136.758957 
	C770.272583,149.440460 779.721436,161.933044 787.882812,175.205688 
	C802.969788,199.741074 815.300659,225.721771 823.008850,253.545898 
	C827.809387,270.874298 831.365967,288.567352 834.972229,306.200775 
	C838.496216,323.432343 839.498108,340.925873 838.889343,358.753662 
	C822.610840,358.753662 806.546509,358.753662 789.999451,358.753662 
	C789.999451,355.334747 790.306824,351.861328 789.945984,348.458801 
	C788.418030,334.050781 786.813354,319.648560 785.009277,305.272736 
	C782.227539,283.106110 775.369995,261.935638 766.558044,241.653107 
	C759.106079,224.500748 750.135742,207.815140 740.078430,192.044693 
	C730.988342,177.790970 719.517456,165.055557 708.962646,151.334076 
z"/>
<path fill="#107DBF" opacity="1.000000" stroke="none" 
	d="
M532.000061,401.432953 
	C533.309021,392.785797 538.521790,388.200348 547.733521,388.063232 
	C563.219971,387.832703 578.737183,387.466095 594.193237,388.188965 
	C604.166199,388.655396 614.492188,389.207123 623.014832,395.967255 
	C630.699097,402.062317 635.581787,409.318939 636.148743,419.584991 
	C636.665955,428.951813 636.221191,437.967499 630.064636,445.346802 
	C626.446106,449.683929 621.502014,452.915039 617.182068,456.619598 
	C618.932312,457.948090 622.956543,459.546814 624.455078,462.449432 
	C627.382263,468.119751 629.271667,474.421021 630.897278,480.642273 
	C632.665344,487.408722 633.222534,494.497070 635.070312,501.235962 
	C637.691223,510.794464 636.221313,516.622681 628.295654,519.057617 
	C619.430908,521.781067 611.539856,520.785034 607.733521,511.903839 
	C604.716858,504.865204 603.819702,496.915680 602.008118,489.364227 
	C601.210815,486.040649 600.886719,482.538116 599.630859,479.404053 
	C597.282837,473.544495 592.151733,471.274750 586.257690,471.070007 
	C578.446777,470.798645 570.619385,471.003143 562.000793,471.003143 
	C562.000793,472.942596 562.044250,474.689056 561.993713,476.432800 
	C561.677124,487.356232 561.522644,498.290100 560.861389,509.193054 
	C560.721313,511.503387 559.093140,514.042358 557.474182,515.880249 
	C553.652893,520.218201 546.151184,521.496643 540.674011,519.223755 
	C534.458191,516.644226 532.001404,512.855408 532.000916,505.815277 
	C531.998718,471.171295 531.999817,436.527344 532.000061,401.432953 
M604.593079,437.862488 
	C610.917480,425.273743 603.325317,413.121887 588.900391,413.972260 
	C585.253662,414.187256 581.583679,414.009735 577.924377,414.010498 
	C572.678833,414.011597 567.433228,414.010742 562.269409,414.010742 
	C562.269409,425.371185 562.269409,435.953583 562.269409,447.434814 
	C572.759827,446.905334 583.036743,447.017761 593.086853,445.562744 
	C597.002808,444.995819 600.407776,440.898407 604.593079,437.862488 
z"/>
<path fill="#FA7412" opacity="1.000000" stroke="none" 
	d="
M251.948883,443.563232 
	C249.453125,445.474030 246.747055,446.724152 245.156479,448.820618 
	C240.600540,454.825500 232.227356,456.176300 226.235168,450.999084 
	C220.933899,446.418823 220.399216,439.766418 225.258636,433.261017 
	C231.311539,425.157837 240.414078,422.159698 249.631027,421.262207 
	C261.555634,420.101074 273.743805,419.466156 285.398376,423.977264 
	C296.267090,428.184174 303.136200,436.119263 303.801636,447.550629 
	C304.880493,466.084564 304.898132,484.694031 304.869263,503.270813 
	C304.859802,509.344910 303.299957,515.905823 297.183289,518.744690 
	C290.349274,521.916443 283.006836,520.218079 279.592102,513.144958 
	C279.104828,512.135559 278.430756,511.216370 277.948730,510.428101 
	C262.563843,521.622192 246.334122,525.079041 228.880035,516.304016 
	C220.325516,512.003296 216.142593,504.489044 214.863068,494.929047 
	C214.103210,489.251678 214.894547,484.071106 216.611023,478.792603 
	C218.850327,471.906372 223.573578,467.098450 230.179642,465.087616 
	C240.688492,461.888763 251.481384,459.616394 262.173126,457.030701 
	C264.382446,456.496399 266.996246,456.872925 268.852020,455.821167 
	C271.482819,454.330139 273.583160,451.903229 275.910217,449.876282 
	C273.344482,447.587219 271.057587,443.896423 268.151611,443.318481 
	C263.050232,442.303925 257.569702,443.195770 251.948883,443.563232 
M276.995575,483.951996 
	C276.995575,480.473755 276.995575,476.995544 276.995575,473.008850 
	C267.383514,475.749908 258.082977,478.351013 248.816284,481.067596 
	C244.565933,482.313599 242.989273,485.712860 243.076584,489.726532 
	C243.170059,494.024292 246.206253,496.456421 249.862442,497.879791 
	C259.415070,501.598633 271.760681,495.571075 276.995575,483.951996 
z"/>
<path fill="#107DBF" opacity="1.000000" stroke="none" 
	d="
M687.124268,442.072937 
	C679.827820,442.408936 675.038025,446.093994 670.366943,450.885590 
	C665.657043,455.716888 655.774231,455.085236 651.985779,450.473755 
	C647.978760,445.596161 648.304688,437.431458 653.236633,432.149261 
	C660.339417,424.542114 669.676758,421.791443 679.241882,421.276855 
	C689.192383,420.741547 699.501160,421.210663 709.208984,423.302368 
	C720.422668,425.718506 730.217651,434.503693 730.867798,447.876892 
	C731.770386,466.441864 731.875916,485.056030 731.831726,503.647949 
	C731.822693,507.451996 730.432434,511.777161 728.313538,514.950439 
	C722.669739,523.402344 709.557922,521.986084 704.550964,510.255890 
	C695.010559,519.480469 683.283508,522.002563 670.666992,520.937683 
	C655.820190,519.684570 643.737854,511.301575 641.977661,495.365051 
	C639.982849,477.304901 647.455811,466.408813 665.561096,462.039459 
	C675.369019,459.672546 685.336792,457.964417 695.241333,456.003693 
	C698.802979,455.298615 702.710876,454.006836 702.640320,450.095551 
	C702.565674,445.953827 698.717407,443.955902 694.827026,443.089111 
	C692.441833,442.557648 689.980225,442.369141 687.124268,442.072937 
M680.652954,478.988373 
	C679.589050,479.401184 678.489075,479.740265 677.467224,480.239227 
	C672.059692,482.879822 669.130005,487.203644 670.074585,491.068573 
	C671.242737,495.848541 675.990173,498.959930 682.176392,498.999847 
	C697.085510,499.096100 704.952209,489.856506 703.754089,473.524567 
	C696.309265,475.310394 688.882263,477.091888 680.652954,478.988373 
z"/>
<path fill="#FA7412" opacity="1.000000" stroke="none" 
	d="
M210.000183,453.213989 
	C210.333771,459.735718 210.913193,465.822845 210.907211,471.909424 
	C210.903336,475.851471 206.570679,478.988251 201.960983,478.993134 
	C185.469543,479.010620 168.978058,479.000092 152.486603,479.000183 
	C150.831284,479.000183 149.175964,479.000244 147.300934,479.000244 
	C148.412918,489.653351 153.702866,496.280243 164.058441,498.536469 
	C171.568634,500.172729 177.355881,497.015717 182.562759,491.983337 
	C189.505463,485.273254 199.072586,486.957855 203.160477,495.499298 
	C205.950653,501.329224 203.736069,509.393250 197.088181,512.788391 
	C190.278549,516.266052 182.914734,519.740662 175.477921,520.657715 
	C163.972229,522.076599 152.122696,521.786377 141.413727,515.769836 
	C126.555923,507.422272 119.341751,494.464844 117.932365,477.702728 
	C116.987679,466.467346 117.919945,455.645325 123.185326,445.547516 
	C130.983063,430.593262 143.640106,423.123322 160.200668,420.820435 
	C168.604874,419.651794 176.526199,420.753479 184.221558,423.214630 
	C197.136993,427.345306 204.568954,437.173889 209.001083,449.559082 
	C209.379303,450.615967 209.667633,451.705017 210.000183,453.213989 
M171.988785,443.042938 
	C168.652313,443.030701 165.273209,442.672516 161.988159,443.077423 
	C154.889633,443.952515 148.545609,451.066528 148.501358,457.756409 
	C160.254608,457.756409 172.006073,457.756409 183.953094,457.756409 
	C183.250443,450.326538 178.797485,446.191986 171.988785,443.042938 
z"/>
<path fill="#FA7412" opacity="1.000000" stroke="none" 
	d="
M430.948608,488.000244 
	C437.315552,488.570526 441.509491,491.703674 442.869781,497.434937 
	C444.385284,503.820404 442.065521,509.725311 436.398834,512.662598 
	C429.601440,516.186035 422.226532,519.782166 414.791901,520.629883 
	C401.406372,522.155945 387.748657,521.574402 376.132080,512.999695 
	C364.256775,504.234100 357.710510,492.329468 357.085052,477.576172 
	C356.683289,468.099060 356.800629,458.745667 360.602936,449.508270 
	C366.471741,435.250671 376.585846,426.246155 391.161926,422.508850 
	C405.430206,418.850433 419.574860,419.261963 432.354889,427.807129 
	C442.925903,434.875244 448.090515,445.430115 449.894470,457.652893 
	C450.546112,462.068176 450.180023,466.669373 449.953339,471.169373 
	C449.687531,476.445740 446.765717,478.980408 441.279480,478.989563 
	C423.785706,479.018768 406.291840,478.998810 388.798004,479.010010 
	C387.976898,479.010529 387.155884,479.128235 386.084564,479.210602 
	C388.138550,488.909729 392.270355,496.343567 402.881989,498.482025 
	C410.013519,499.919159 415.401459,497.102661 420.769562,492.912201 
	C423.585785,490.713837 427.250275,489.602142 430.948608,488.000244 
M417.287811,458.000061 
	C419.280914,458.000061 421.274048,458.000061 423.288361,458.000061 
	C421.783325,448.695923 414.019043,441.824982 405.377563,442.035645 
	C396.411591,442.254211 387.735687,449.835236 387.422455,458.000061 
	C397.066315,458.000061 406.701874,458.000061 417.287811,458.000061 
z"/>
<path fill="#107DBF" opacity="1.000000" stroke="none" 
	d="
M853.090454,497.417694 
	C855.759766,495.450104 858.261658,493.894745 860.459534,491.988770 
	C866.516418,486.736572 873.369507,486.639862 878.424011,491.918976 
	C883.310364,497.022522 883.681946,505.235382 878.203003,510.022522 
	C874.140015,513.572510 869.141418,516.623962 864.035217,518.296326 
	C850.584961,522.701477 836.847595,522.481323 823.458923,517.717773 
	C808.725281,512.475769 801.037903,500.952972 797.045898,486.519440 
	C792.913025,471.576538 794.783325,457.095367 802.205078,443.721252 
	C810.074280,429.540894 822.831604,422.104095 838.953674,421.089752 
	C848.798889,420.470306 858.656433,420.593323 867.688049,425.879730 
	C878.718445,432.336151 885.378662,441.869812 887.896423,454.190887 
	C888.876770,458.988373 888.860657,464.025391 888.952209,468.959717 
	C889.072021,475.415161 885.367126,478.997375 879.002563,478.998688 
	C861.194763,479.002380 843.386902,479.000000 825.611206,479.000000 
	C824.466675,491.309845 838.071838,503.057190 853.090454,497.417694 
M856.270386,457.999786 
	C858.056030,457.999786 859.841736,457.999786 861.670898,457.999786 
	C860.614502,448.650818 853.925232,442.048889 841.703125,442.920959 
	C833.671448,443.494019 827.552979,448.918152 825.964783,457.999817 
	C835.766357,457.999817 845.546570,457.999817 856.270386,457.999786 
z"/>
<path fill="#107DBF" opacity="1.000000" stroke="none" 
	d="
M786.843506,497.992371 
	C793.342773,499.356445 793.167480,504.045715 793.001953,508.740234 
	C792.838867,513.364990 789.455566,518.257996 784.322815,518.670471 
	C776.580811,519.292542 768.585022,519.486755 760.967224,518.228088 
	C751.568848,516.675354 747.245117,510.304657 747.071716,499.660095 
	C746.800598,483.017242 746.999939,466.366730 747.000000,449.719482 
	C747.000000,447.926605 747.000000,446.133728 747.000000,444.419037 
	C738.185669,443.424469 733.399292,440.029602 732.998352,434.807831 
	C732.446228,427.615326 734.629028,425.495636 746.487427,421.642212 
	C746.986572,414.878418 747.184570,408.115814 748.078491,401.446503 
	C748.726196,396.613892 755.194336,392.099762 760.452698,392.022766 
	C766.337891,391.936584 771.906250,395.112701 772.976501,400.270508 
	C774.400513,407.132904 774.921509,414.182648 775.720398,420.307800 
	C780.581482,422.489349 785.709839,424.285980 790.202942,427.097717 
	C791.656433,428.007324 792.004517,431.609009 791.887207,433.930145 
	C791.531555,440.963623 787.330994,443.493164 775.001343,444.238129 
	C775.001343,446.099579 775.001404,448.017334 775.001404,449.935089 
	C775.001282,462.919952 774.997437,475.904785 775.002502,488.889648 
	C775.004944,495.223328 776.196289,496.441101 782.645386,497.034088 
	C783.923584,497.151581 785.166504,497.652466 786.843506,497.992371 
z"/>
<path fill="#FA7412" opacity="1.000000" stroke="none" 
	d="
M316.000000,405.053772 
	C316.226013,401.305573 315.869568,397.871826 316.789825,394.823456 
	C319.306396,386.487213 326.459808,386.054138 333.839935,387.213806 
	C340.984222,388.336426 343.653809,393.001373 343.885162,401.340942 
	C344.296112,416.151917 344.000122,430.982544 344.000153,445.804932 
	C344.000214,464.957458 344.059570,484.110382 343.937317,503.262146 
	C343.918884,506.148285 343.424896,509.153992 342.504913,511.886932 
	C340.403931,518.128357 333.331390,521.434082 326.019104,519.966064 
	C319.884613,518.734497 316.014038,513.790771 316.009644,506.969238 
	C315.987762,473.160828 315.999878,439.352448 316.000000,405.053772 
z"/>
<path fill="#FA7412" opacity="1.000000" stroke="none" 
	d="
M459.114929,511.298950 
	C458.675751,488.649597 458.186493,466.405609 458.093689,444.159973 
	C458.072174,439.004852 458.862183,433.690002 460.273224,428.731628 
	C461.545502,424.260834 469.355927,420.266876 473.310730,421.061890 
	C480.510712,422.509186 484.294281,426.335785 485.008636,432.882233 
	C485.077911,433.517303 485.192200,434.147461 485.443451,435.848724 
	C486.619812,434.186066 487.455658,433.328430 487.916962,432.302399 
	C492.258392,422.646667 505.844940,418.857391 514.312073,421.949677 
	C520.235291,424.112915 522.847168,428.632477 521.994446,436.066010 
	C521.339294,441.777313 517.075745,445.584869 511.185913,446.034760 
	C507.120911,446.345245 502.889954,446.390961 499.072083,447.613434 
	C492.107483,449.843475 488.703735,455.613098 488.121948,462.489044 
	C487.314026,472.037811 487.283203,481.655212 487.021912,491.246063 
	C486.894928,495.907379 487.000488,500.575073 486.999908,505.239868 
	C486.998901,513.382263 484.272217,517.277832 477.037231,519.475281 
	C470.552612,521.444885 463.854462,518.887085 459.964264,512.951233 
	C459.698029,512.544922 459.460175,512.119995 459.114929,511.298950 
z"/>
<path fill="#127EC0" opacity="1.000000" stroke="none" 
	d="
M833.730896,542.339966 
	C840.683533,552.055115 838.907166,564.245117 832.356384,570.123169 
	C825.700989,576.094971 815.574829,577.210083 807.407654,572.700012 
	C798.225220,567.629333 796.741150,557.977661 798.400940,551.248962 
	C800.767334,541.655273 808.388062,536.270630 818.117615,535.912231 
	C824.331970,535.683350 828.966797,538.538391 833.730896,542.339966 
M820.571594,540.882324 
	C816.471802,538.584351 813.289490,541.373352 810.134827,543.074341 
	C804.521912,546.100891 800.114807,555.876099 806.459229,564.924622 
	C811.140564,571.601196 820.109497,572.758972 825.706421,568.170898 
	C824.132568,566.166443 822.652222,564.177246 821.059265,562.282776 
	C819.610046,560.559265 818.038391,558.938660 816.520752,557.272644 
	C816.018066,557.605896 815.515381,557.939148 815.012695,558.272339 
	C815.012695,561.018127 815.012695,563.763977 815.012695,566.718323 
	C813.159058,566.718323 811.779907,566.718323 810.336548,566.718323 
	C810.336548,559.405884 810.336548,552.359985 810.336548,545.008362 
	C814.135376,545.008362 817.615051,544.827942 821.067810,545.055237 
	C825.147400,545.323730 828.629028,549.615601 826.592041,552.408691 
	C822.697388,557.748840 827.194031,561.275391 828.218750,565.752258 
	C829.786621,564.356812 831.129211,562.948914 831.800293,561.272339 
	C835.343750,552.418640 830.630188,543.380981 820.571594,540.882324 
M817.327515,553.993286 
	C818.895325,553.496765 820.463074,553.000305 822.030884,552.503845 
	C822.068970,551.999756 822.106995,551.495728 822.145020,550.991699 
	C820.006958,550.193970 817.868896,549.396240 815.730835,548.598572 
	C815.337708,549.019653 814.944519,549.440796 814.551392,549.861938 
	C815.201538,551.230164 815.851685,552.598389 817.327515,553.993286 
z"/>
<path fill="#FFF" opacity="0.000000" stroke="none" 
	d="
M70.245529,421.745270 
	C75.990494,427.854919 77.833298,435.076630 79.129730,442.783356 
	C80.663734,451.902344 79.992050,460.750061 78.005272,469.624969 
	C75.111343,482.552216 67.327988,492.406219 52.619480,493.041168 
	C45.579716,493.345062 38.552948,493.949982 31.240356,494.437195 
	C31.240356,467.283783 31.240356,441.015808 31.240356,414.081573 
	C44.517544,414.695282 58.503632,410.880157 70.245529,421.745270 
z"/>
<path fill="#FFF" opacity="0.000000" stroke="none" 
	d="
M604.319275,438.135803 
	C600.407776,440.898407 597.002808,444.995819 593.086853,445.562744 
	C583.036743,447.017761 572.759827,446.905334 562.269409,447.434814 
	C562.269409,435.953583 562.269409,425.371185 562.269409,414.010742 
	C567.433228,414.010742 572.678833,414.011597 577.924377,414.010498 
	C581.583679,414.009735 585.253662,414.187256 588.900391,413.972260 
	C603.325317,413.121887 610.917480,425.273743 604.319275,438.135803 
z"/>
<path fill="#FFF" opacity="0.000000" stroke="none" 
	d="
M276.982147,484.380859 
	C271.760681,495.571075 259.415070,501.598633 249.862442,497.879791 
	C246.206253,496.456421 243.170059,494.024292 243.076584,489.726532 
	C242.989273,485.712860 244.565933,482.313599 248.816284,481.067596 
	C258.082977,478.351013 267.383514,475.749908 276.995575,473.008850 
	C276.995575,476.995544 276.995575,480.473755 276.982147,484.380859 
z"/>
<path fill="#FFF" opacity="0.000000" stroke="none" 
	d="
M681.054077,478.930908 
	C688.882263,477.091888 696.309265,475.310394 703.754089,473.524567 
	C704.952209,489.856506 697.085510,499.096100 682.176392,498.999847 
	C675.990173,498.959930 671.242737,495.848541 670.074585,491.068573 
	C669.130005,487.203644 672.059692,482.879822 677.467224,480.239227 
	C678.489075,479.740265 679.589050,479.401184 681.054077,478.930908 
z"/>
<path fill="#FFF" opacity="0.000000" stroke="none" 
	d="
M172.373520,443.163116 
	C178.797485,446.191986 183.250443,450.326538 183.953094,457.756409 
	C172.006073,457.756409 160.254608,457.756409 148.501358,457.756409 
	C148.545609,451.066528 154.889633,443.952515 161.988159,443.077423 
	C165.273209,442.672516 168.652313,443.030701 172.373520,443.163116 
z"/>
<path fill="#FFF" opacity="0.000000" stroke="none" 
	d="
M416.812622,458.000061 
	C406.701874,458.000061 397.066315,458.000061 387.422455,458.000061 
	C387.735687,449.835236 396.411591,442.254211 405.377563,442.035645 
	C414.019043,441.824982 421.783325,448.695923 423.288361,458.000061 
	C421.274048,458.000061 419.280914,458.000061 416.812622,458.000061 
z"/>
<path fill="#FFF" opacity="0.000000" stroke="none" 
	d="
M855.798584,457.999817 
	C845.546570,457.999817 835.766357,457.999817 825.964783,457.999817 
	C827.552979,448.918152 833.671448,443.494019 841.703125,442.920959 
	C853.925232,442.048889 860.614502,448.650818 861.670898,457.999786 
	C859.841736,457.999786 858.056030,457.999786 855.798584,457.999817 
z"/>
<path fill="#FFF" opacity="0.000000" stroke="none" 
	d="
M820.963135,540.935120 
	C830.630188,543.380981 835.343750,552.418640 831.800293,561.272339 
	C831.129211,562.948914 829.786621,564.356812 828.218750,565.752258 
	C827.194031,561.275391 822.697388,557.748840 826.592041,552.408691 
	C828.629028,549.615601 825.147400,545.323730 821.067810,545.055237 
	C817.615051,544.827942 814.135376,545.008362 810.336548,545.008362 
	C810.336548,552.359985 810.336548,559.405884 810.336548,566.718323 
	C811.779907,566.718323 813.159058,566.718323 815.012695,566.718323 
	C815.012695,563.763977 815.012695,561.018127 815.012695,558.272339 
	C815.515381,557.939148 816.018066,557.605896 816.520752,557.272644 
	C818.038391,558.938660 819.610046,560.559265 821.059265,562.282776 
	C822.652222,564.177246 824.132568,566.166443 825.706421,568.170898 
	C820.109497,572.758972 811.140564,571.601196 806.459229,564.924622 
	C800.114807,555.876099 804.521912,546.100891 810.134827,543.074341 
	C813.289490,541.373352 816.471802,538.584351 820.963135,540.935120 
z"/>
<path fill="#FFF" opacity="0.000000" stroke="none" 
	d="
M816.914673,553.979980 
	C815.851685,552.598389 815.201538,551.230164 814.551392,549.861938 
	C814.944519,549.440796 815.337708,549.019653 815.730835,548.598572 
	C817.868896,549.396240 820.006958,550.193970 822.145020,550.991699 
	C822.106995,551.495728 822.068970,551.999756 822.030884,552.503845 
	C820.463074,553.000305 818.895325,553.496765 816.914673,553.979980 
z"/>
</svg>
    );
}


